import React from 'react';
import { Query } from '@apollo/client/react/components';

import LoadingProgress from 'lib/react-router/loading-progress';
import ErrorPage from 'four-nets/errors/error-page';

import { RouteWithSearchRenderProps } from 'lib/react-router/route-with-search';

import query, { PostLoaderQuery, PostLoaderQueryVariables } from './post-loader.graphql';
import Post from '../../feed-post/feed-post';

interface Params {
    id: string;
}

export interface Props extends RouteWithSearchRenderProps<Params, {}> {}

class PostLoader extends React.PureComponent<Props> {
    render() {
        return (
            <Query<PostLoaderQuery, PostLoaderQueryVariables>
                query={query}
                variables={{ id: this.props.match.params.id }}
            >
                {({ error, data, loading }) => {
                    return (
                        <LoadingProgress loading={loading}>
                            <ErrorPage error={error}>{data ? <Post {...data.post} /> : null}</ErrorPage>
                        </LoadingProgress>
                    );
                }}
            </Query>
        );
    }
}

export default PostLoader;
